export default { API: { gutenberg: { baseURL: process.env.VUE_APP_GUTENBERG_API_URL } } };